import type { ModulePermission } from './modulePermission'
import api from '../index'

export interface Module {
  id: number
  name: string
  description: string
  price: string
  status: 1 | 2
  is_trial: number
  trial_days: number
  icon: string | null
  image?: string | null
  path: string
  sort?: number
  menu_count?: number
  deleted_at: string | null
  created_at: string
  updated_at: string
  iconLoaded?: boolean
  // 试用相关字段
  try_on?: number
  try_on_day?: number
  // 可见性字段
  is_visible: 1 | 2
  // 新团队及新成员的模块级默认授权
  default_team_enabled?: 0 | 1
  default_member_enabled?: 0 | 1
  access_mode?: 'system' | 'entitlement'
  billing_duration_days?: number
  children?: ModuleMenu[]
}

export interface ModuleFormData {
  path: string
  name: string
  icon?: string | null
  image?: string | null
  description?: string
  price?: number
  sort?: number
  status?: 1 | 2
  is_visible?: 1 | 2
  is_trial?: 1 | 2
  trial_days?: number
  access_mode?: 'system' | 'entitlement'
  billing_duration_days?: number
  default_team_enabled?: 0 | 1
  default_member_enabled?: 0 | 1
}

export interface ModuleMenu {
  id: number
  module_id: number
  pid: number
  name: string
  path?: string
  icon?: string | null
  image?: string | null
  description?: string
  sort?: number
  status: 1 | 2
  is_visible: 1 | 2
  is_default_home: 0 | 1
  active_menu?: string | null
  created_at?: string
  updated_at?: string
  children: ModuleMenu[]
  permissions?: ModulePermission[]
}

export interface ModuleMenuFormData {
  module_id?: number
  pid?: number
  name: string
  path?: string | null
  icon?: string | null
  image?: string | null
  description?: string
  sort?: number
  status?: 1 | 2
  is_visible?: 1 | 2
  is_default_home?: 0 | 1
  active_menu?: string | null
}

export interface ModuleListParams {
  page_no?: number
  page_size?: number
  page_type?: string
  keyword?: string
  status?: 1 | 2
  access_mode?: 'system' | 'entitlement'
}

export interface ModuleGiftData {
  user_team_id: number
  module_id: number
  duration_days: number
  remark?: string
}

export interface ModuleGiftListParams {
  user_team_id?: number
  module_id?: number
  operator_admin_id?: number
  gift_no?: string
  status?: number
  page?: number
  pageSize?: number
}

export interface ModuleGiftRecord {
  id: number
  gift_no: string
  user_team_id: number
  module_id: number
  operator_admin_id?: number
  start_at: string
  end_at: string
  duration_days: number
  status: number
  is_expired: boolean
  remark?: string
  created_at?: string
  module?: Pick<Module, 'id' | 'name' | 'path' | 'icon' | 'image'>
  user_team?: {
    id: number
    name: string
    code?: string
  }
  operator_admin?: {
    id: number
    username: string
    name?: string
  }
}

export default {
  list: (params?: ModuleListParams) => api.get('module/list', { params }),
  add: (data: ModuleFormData) => api.post('module/add', data),
  update: (id: number, data: Partial<ModuleFormData>) => api.put(`module/edit/${id}`, data),
  delete: (id: number) => api.delete(`module/del/${id}`),
  show: (id: number) => api.get(`module/show/${id}`),
  addMenu: (data: ModuleMenuFormData) => api.post('module/menu/add', data),
  updateMenu: (id: number, data: Partial<ModuleMenuFormData>) => api.put(`module/menu/edit/${id}`, data),
  deleteMenu: (id: number) => api.delete(`module/menu/del/${id}`),
  gift: (data: ModuleGiftData) => api.post('module/gift', data),
  giftList: (params?: ModuleGiftListParams) => api.get('module/gift/list', { params }),
}
